module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-rts-today.c5ab73bc.svg";